
import { Directive, ViewContainerRef, TemplateRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: '[sdDesktop]'
})
export class DesktopDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    deviceService: DeviceDetectorService,
  ) {
    if (deviceService.isDesktop()) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
